export function astMaskCel(value) {
	if (value) {
		const iniValue = value.substring(1, 3)
		const endValue = value.substring(value.length - 4);
		return `(${iniValue}) *****${endValue}`;
	} else {
		return '';
	}
}

export function newToken() {
	const token = (Math.floor(Math.random() * 10) + '' + Math.floor(Math.random() * 10) + '' + Math.floor(Math.random() * 10) + '' + Math.floor(Math.random() * 10))
	return token;
}

export function cepFormat({ cep }) {
	if (cep) {
		cep = cep.replace(/\D/g, '');
		cep = cep.replace(/(\d{5})(\d)/, '$1-$2');
	}
	return cep;
}

export function preventSQLI(str) {
	var preventSQLI = str.replace(/'\D{0}/g, '');
	preventSQLI = preventSQLI.replace(/"\D{0}/g, '');
	preventSQLI = preventSQLI.replace(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g, "")
	return preventSQLI;
}

const CNPJ_FIRST_CHECK_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_SECOND_CHECK_DIGIT_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function applyDocumentPattern(value, pattern) {
	let result = '';
	let valueIndex = 0;

	for (let patternIndex = 0; patternIndex < pattern.length && valueIndex < value.length; patternIndex++) {
		if (pattern[patternIndex] === '#') {
			result += value[valueIndex];
			valueIndex += 1;
		} else {
			result += pattern[patternIndex];
		}
	}

	return result;
}

function calculateCnpjCheckDigit(value, weights) {
	const sum = value
		.split('')
		.reduce((acc, char, index) => acc + ((char.charCodeAt(0) - 48) * weights[index]), 0);
	const remainder = sum % 11;

	return remainder < 2 ? '0' : String(11 - remainder);
}

export function normalizeCpfOrCnpj(cpfOuCnpj = '') {
	return String(cpfOuCnpj || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
}

export function isValidAlphanumericCnpj(cpfOuCnpj) {
	const cnpj = normalizeCpfOrCnpj(cpfOuCnpj);

	if (cnpj.length !== 14 || !/^[0-9A-Z]{12}\d{2}$/.test(cnpj)) {
		return false;
	}

	if (/^([0-9A-Z])\1{13}$/.test(cnpj)) {
		return false;
	}

	const base = cnpj.substring(0, 12);
	const firstCheckDigit = calculateCnpjCheckDigit(base, CNPJ_FIRST_CHECK_DIGIT_WEIGHTS);
	const secondCheckDigit = calculateCnpjCheckDigit(`${base}${firstCheckDigit}`, CNPJ_SECOND_CHECK_DIGIT_WEIGHTS);

	return cnpj === `${base}${firstCheckDigit}${secondCheckDigit}`;
}

export function formatCpfOrCnpj(cpfOuCnpj = '') {
	const normalized = normalizeCpfOrCnpj(cpfOuCnpj);
	const hasLetters = /[A-Z]/.test(normalized);

	if (!hasLetters && normalized.length <= 11) {
		return applyDocumentPattern(normalized.substring(0, 11), '###.###.###-##');
	}

	const cnpjBase = normalized.substring(0, 12);
	const cnpjCheckDigits = normalized.substring(12).replace(/\D/g, '').substring(0, 2);

	return applyDocumentPattern(`${cnpjBase}${cnpjCheckDigits}`, '##.###.###/####-##');
}

export function traduzTipoItem(id) {
	var type = "";
	if (Number(id) === 1) {
		type = "Ar Condicionado";
	}
	if (Number(id) === 2) {
		type = "Cooktop";
	}
	if (Number(id) === 3) {
		type = "Coifa";
	}
	return type;
}

export function getItemTypeIcon(id) {
	if (id === 1) {
		return `${process.env.PUBLIC_URL}/static/services/evaporator.png`
	}
	if (id === 2) {
		return `${process.env.PUBLIC_URL}/static/services/stove.png`
	}
	if (id === 3) {
		return `${process.env.PUBLIC_URL}/static/services/kitchen-hood.png`
	}
	return `${process.env.PUBLIC_URL}/static/services/evaporator.png`;
}

export function getItemTypeSufixUnit(id) {
	if (id === 1) {
		return "BTU's";
	}
	if (id === 2) {
		return "queimadores";
	}
	if (id === 3) {
		return "cm";
	}
	return "";
}

export function getItemTypeUnit(id) {
	if (id === 1) {
		return "Pôtencia (BTU's)";
	}
	if (id === 2) {
		return 'Queimadores (n°)';
	}
	if (id === 3) {
		return 'Tamanho (cm)';
	}
	return '';
}

export const insuranceStatus = {
	incompleto: 'Preencha os dados faltantes',
	aguardando_cliente: 'Confirme seus dados',
	aguardando_agyx: 'Aguarde o processamento da garantia estendida',
	confirmado: 'Aguarde o processamento da garantia estendida',
	emitido: 'Garantia estendida ativa',
	cancelamento_aguardando_emissao: 'Garantia estendida cancelada',
	cancelamento_emitido: 'Garantia estendida cancelada',
	cancelado: 'Garantia estendida cancelada',
	expirado: 'Expirado'
};

export const insuranceStatusColor = {
  incompleto: '#FFA500', // orange
  aguardando_cliente: '#0000FF', // blue
  aguardando_agyx: '#0000FF', // blue
  confirmado: '#0000FF', // blue
  emitido: '#008000', // green
	cancelamento_aguardando_emissao: '#FF0000', // red
	cancelamento_emitido: '#FF0000', // red
  cancelado: '#FF0000', // red
  expirado: '#FF0000', // red
};

export function removeCpfOrCnpjMask(cpfOuCnpj) {
	return normalizeCpfOrCnpj(cpfOuCnpj);
}

export function removeCepMask(cep) {
	return cep.replace(/\D/g, '');
}

export function removePhoneMask(telefone) {
	return telefone.replace(/\D/g, '');
}

export function isNullOrEmpty(str) {
  return !str || str.trim() === '';
}

export function removeNullAndUndefined(obj) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === 'null' || obj[key] === 'undefined') {
      delete obj[key];
    }
  }
	return obj;
}

export function isClientDomain() {
	const currentDomain = window.location.hostname;
	if (['cliente.dev.agyx.com.br', 'cliente.agyx.com.br', 'localhost'].includes(currentDomain)) {
		console.log(`CLIENT DOMAIN -> ${currentDomain}`);
		return true
	} else {
		console.log(`SELLER DOMAIN -> ${currentDomain}`);
		return false;
	}
}
